module.exports = __webpack_public_path__ + "static/media/b3_p11_boomer.07ff8ae7.mp3";